module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-horizontal-497b4df4201159798dca5b59369baaae.svg";